import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { fetchApiDataIfNeeded } from '../../../actions/api'
import { createSelector } from '@reduxjs/toolkit'
// import AdminSidebar from '../../shared/admin-sidebar'

import { PaginationWrapper } from 'shs-pagination'

const selectTemplates = state => state.adminInputTemplates
const selectTemplatePaginator = state => state.paginator.adminInputTemplates

const makeTemplates = createSelector(
    [selectTemplates, selectTemplatePaginator],
    (templates, paginator) => {
        if (paginator) {
            return templates
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state) => {
    const paginator = selectTemplatePaginator(state)
    const templates = makeTemplates(state)
    return { paginator, templates }
}

const AdminTemplateList = ({ dispatch, templates, paginator }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/input-templates', 'LIST')))
    }, [dispatch])

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint(`admin/input-templates`, 'LIST'), paginationParams))
    }

    const renderTemplateRow = (template, index) => {
        return (
            <tr key={template.id}>
                <td>{template.name}</td>
                <td>{template._computed.manualTitle}</td>
                <td>
                    <Link className="btn outline small" to={buildRoutePath(routes.adminTemplateView.path, { templateId: template.id })}>
                        Manage
                    </Link>
                </td>
            </tr>
        )
    }

    const renderTemplates = () => {
        if (!paginator) {
            return null
        }

        let allTemplates = []
        templates.forEach((template, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allTemplates.push(renderTemplateRow(template, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: false } }}
                callbackFX={handlePaginationUpdate}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Manual</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allTemplates}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Templates</h1>
                    </div>
                    <div className="header-actions">
                        <Link to={routes.adminTemplateCreate.path} className="btn blue main">
                            Create New Template
                        </Link>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    {renderTemplates()}
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(AdminTemplateList)
